export default function buildPreviewUrl(groupDomain, slugPath, pageType, previewSlug) {
  let url = `${groupDomain}${slugPath}`;
  if (pageType !== 'page' && !url.endsWith('/')) url += '/';
  return `${url}?preview=${previewSlug}`;
}
